import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaHome, FaSearch, FaArrowLeft } from 'react-icons/fa';

function NotFound() {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | 6G AI Sweden</title>
        <meta name="description" content="The page you're looking for doesn't exist. Return to 6G AI Sweden's homepage." />
      </Helmet>

      <section className="not-found-section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center">
              <div className="not-found-content">
                <h1 className="not-found-number">404</h1>
                <h2 className="not-found-title">Page Not Found</h2>
                <p className="not-found-text">
                  The page you're looking for doesn't exist or has been moved.
                </p>
                <div className="not-found-actions">
                  <Button variant="primary" as={Link} to="/" size="lg">
                    <FaHome /> Go to Homepage
                  </Button>
                  <Button variant="outline-light" as={Link} to="/contact" size="lg">
                    <FaSearch /> Contact Us
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default NotFound;
